// import "babel-polyfill";
import Vue from 'vue'
import App from './App.vue'
import axios from 'axios';
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import VueI18n from 'vue-i18n'
import Locale from './locale';
const Locales = Locale;
import 'swiper/dist/css/swiper.css'

import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 路由配置
const routes = [
]
const router = new VueRouter({
    mode: 'history',
    routes // (缩写) 相当于 routes: routes
})
Vue.config.productionTip = false;

Vue.use(VueI18n);

const i18n = new VueI18n({
    locale: 'zh_CN',
    messages:Locales
});

// set lang
i18n.locale = 'zh_CN';


Vue.use(iView,axios);


new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app')
